import React, { Component } from "react";
import PropTypes from "prop-types";
import { format } from "d3-format";
import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import { isDefined, functor } from "../utils";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { getSourcePathLabel } from "../utils/getSourcePath";

class RainbowMATooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const {
      onClick,
      fontFamily,
      fontSize,
      displayFormat,
      className,
      yAccessor,
      options,
      appearance,
      labelFill,
      textFill,
    } = this.props;
    const { displayValuesFor } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);

    let sma1 = "n/a",
      sma2 = "n/a",
      sma3 = "n/a",
      sma4 = "n/a",
      sma5 = "n/a";
    let sma6 = "n/a",
      sma7 = "n/a",
      sma8 = "n/a",
      sma9 = "n/a",
      sma10 = "n/a";

    if (isDefined(currentItem) && isDefined(yAccessor(currentItem))) {
      const item = yAccessor(currentItem);
      sma1 = isDefined(item.sma1) ? displayFormat(item.sma1) : "n/a";
      sma2 = isDefined(item.sma2) ? displayFormat(item.sma2) : "n/a";
      sma3 = isDefined(item.sma3) ? displayFormat(item.sma3) : "n/a";
      sma4 = isDefined(item.sma4) ? displayFormat(item.sma4) : "n/a";
      sma5 = isDefined(item.sma5) ? displayFormat(item.sma5) : "n/a";
      sma6 = isDefined(item.sma6) ? displayFormat(item.sma6) : "n/a";
      sma7 = isDefined(item.sma7) ? displayFormat(item.sma7) : "n/a";
      sma8 = isDefined(item.sma8) ? displayFormat(item.sma8) : "n/a";
      sma9 = isDefined(item.sma9) ? displayFormat(item.sma9) : "n/a";
      sma10 = isDefined(item.sma10) ? displayFormat(item.sma10) : "n/a";
    }

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    // Rainbow colors
    const color1 = appearance?.strokeSMA1?.color || "#FF0000";
    const color2 = appearance?.strokeSMA2?.color || "#FF7F00";
    const color3 = appearance?.strokeSMA3?.color || "#FFFF00";
    const color4 = appearance?.strokeSMA4?.color || "#7FFF00";
    const color5 = appearance?.strokeSMA5?.color || "#00FF7F";
    const color6 = appearance?.strokeSMA6?.color || "#00FFFF";
    const color7 = appearance?.strokeSMA7?.color || "#007FFF";
    const color8 = appearance?.strokeSMA8?.color || "#0000FF";
    const color9 = appearance?.strokeSMA9?.color || "#7F00FF";
    const color10 = appearance?.strokeSMA10?.color || "#FF00FF";

    const period = options?.period || 2;
    const sourcePath = options?.sourcePath || "close";
    const sourceLabel = getSourcePathLabel(sourcePath);

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-rainbow-ma"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>
            {`Rainbow MA (${period}, ${sourceLabel}): `}
          </ToolTipTSpanLabel>
          <tspan fill={color1}>{sma1}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>, </ToolTipTSpanLabel>
          <tspan fill={color2}>{sma2}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>, </ToolTipTSpanLabel>
          <tspan fill={color3}>{sma3}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>, </ToolTipTSpanLabel>
          <tspan fill={color4}>{sma4}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>, </ToolTipTSpanLabel>
          <tspan fill={color5}>{sma5}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>, </ToolTipTSpanLabel>
          <tspan fill={color6}>{sma6}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>, </ToolTipTSpanLabel>
          <tspan fill={color7}>{sma7}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>, </ToolTipTSpanLabel>
          <tspan fill={color8}>{sma8}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>, </ToolTipTSpanLabel>
          <tspan fill={color9}>{sma9}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>, </ToolTipTSpanLabel>
          <tspan fill={color10}>{sma10}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

RainbowMATooltip.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  displayValuesFor: PropTypes.func,
  displayFormat: PropTypes.func.isRequired,
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  onClick: PropTypes.func,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  options: PropTypes.shape({
    period: PropTypes.number,
    sourcePath: PropTypes.string,
  }),
  appearance: PropTypes.object,
  textFill: PropTypes.string,
  labelFill: PropTypes.string,
};

RainbowMATooltip.defaultProps = {
  origin: [0, 0],
  className: "react-stockcharts-tooltip react-stockcharts-rainbowma-tooltip",
  displayFormat: format(".2f"),
  displayValuesFor,
  labelFill: "#6B7280",
  textFill: "#F9FAFB",
  fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
  fontSize: 12,
};

export default RainbowMATooltip;
